module.exports = __webpack_public_path__ + "static/media/DMSans_24pt-SemiBold.816685ee.ttf";